<template>
  <div class="bg-surface-canvas dark:bg-surface-level-900">
    <GuestTopBar />

    <CleanNavigation />

    <slot />

    <Footer />
  </div>
</template>

<script setup lang="ts">
import GuestTopBar from '~/components/GuestTopBar.vue'

defineSlots<{
  default?: () => unknown
}>()

// Clean layout with minimal navigation (logo only)
</script>
